export default {
  comma: ' : ',

  osServer: ['orbroServer'],
  osRtls: ['edgeRtls'],
  osAi: ['edgeAi'],
  osSwitch: ['l2Switch'],

  comfortKit: ['uwbTag'],

  //rtls
  twinTracker: ['twinTrackerBle'],
  bleStarterKit: ['edgeRtls', 'l2Switch', 'twinTrackerBle', 'orbroTag', 'plutoconPro', 'coinTag', 'slimTag', 'stickerTag'],
  bleEnterpriseKit: ['orbroServer', 'edgeRtls', 'l2Switch', 'twinTrackerBle', 'orbroTag', 'plutoconPro', 'coinTag', 'slimTag', 'stickerTag'],

  twinTrackerAoa: ['twinTrackerAoA'],
  aoaStarterKit: ['edgeRtls', 'l2Switch', 'twinTrackerAoA', 'orbroAoaTag'],
  aoaEnterpriseKit: ['orbroServer', 'edgeRtls', 'l2Switch', 'twinTrackerAoA', 'orbroAoaTag'],

  twinTrackerUwb: ['twinTrackerUWB'],
  uwbStarterKit: ['edgeRtls', 'l2Switch', 'twinTrackerUWB', 'uwbTag'],
  uwbEnterpriseKit: ['orbroServer', 'edgeRtls', 'l2Switch', 'twinTrackerUWB', 'uwbTag'],

  //camera
  cameraStarterKit: ['edgeAi', 'l2Switch', 'domeCamera', 'ptzCamera'],
  cameraEnterpriseKit: ['orbroServer', 'aiServer'],

  //outdoor
  gpsDevice: ['orbroServer', 'gps'],
  gpsTag: ['orbroServer', 'loraGateway', 'gpsTagLora'],

  // items
  edgeAi: [
    {
      title: 'ORBRO Edge AI',
      serial: 'ONT-EAWF0001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimension',
              desc: '188mm x 108mm x 27mm',
            },
            {
              theme: 'Port Layout',
              desc: '1GbE RJ 45 x 4, HDMI, USB-C, USB-A',
            },
            {
              theme: 'Application',
              desc: 'AI-based Object Tracking',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact Desktop',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Connectivity',
              desc: 'RTSP-based Camera Integration (Supports up to 2 Cameras)',
            },
            {
              theme: 'Object Tracking',
              desc: 'Vehicles, People, Trucks',
            },
            {
              theme: 'AI Processing',
              desc: 'Real-time Object Detection & Classification',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Wired',
              desc: 'Ethernet',
            },
            {
              theme: 'Wireless',
              desc: 'Wi-Fi, Bluetooth',
            },
            {
              theme: 'Power',
              desc: '(1) USB Type-C, 5V DC, 3A, (2) PoE',
            },
            {
              theme: 'Weight',
              desc: '300g',
            },
            {
              theme: 'Enclosure Material',
              desc: 'ABS/White, PC/Translucent White',
            },
            {
              theme: 'Ambient Operating Temperature',
              desc: '-5 to 45° C (23 to 113° F)',
            },
            {
              theme: 'Ambient Operating Humidity',
              desc: '10 to 90% noncondensing',
            },
            {
              theme: 'Certifications',
              desc: 'KC',
            },
          ],
        },
      ],
    },
  ],

  l2Switch: [
    {
      title: 'L2 Switch',
      serial: 'ONT-LRBT5001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimension',
              desc: '188mm x 108mm x 38mm',
            },
            {
              theme: 'Port Layout',
              desc: '100Base-TX x 8',
            },
            {
              theme: 'Application',
              desc: 'Compact L2 Switching for Edge Devices',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact Desktop',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Connectivity',
              desc: '8-Port Fast Ethernet',
            },
            {
              theme: 'Wireless Support',
              desc: 'BLE, Wi-Fi',
            },
            {
              theme: 'PoE Support',
              desc: 'IEEE 802.af/at compliant',
            },
            {
              theme: 'Management Interface',
              desc: 'Web-based UI / Ethernet-based Configuration (if applicable)',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Enclosure Material',
              desc: 'ABS/White, PC/Translucent White, Silicon Gray',
            },
            {
              theme: 'Processor',
              desc: 'Dual-core 32-bit LX6, 240MHz',
            },
            {
              theme: 'Memory',
              desc: '448KB ROM, 520KB SRAM',
            },
            {
              theme: 'Power Input',
              desc: '48–54V DC (via Adaptor), PoE support',
            },
            {
              theme: 'Weight',
              desc: 'TBD',
            },
            {
              theme: 'Ambient Operating Temperature',
              desc: '-20 to 60°C',
            },
            {
              theme: 'Ambient Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
            {
              theme: 'Certifications',
              desc: 'KC',
            },
          ],
        },
      ],
    },
  ],

  domeCamera: [
    {
      title: 'Dome Camera',
      serial: '', // 시리얼 넘버가 명시되지 않았으므로 비워둡니다
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimension',
              desc: '135mm x 135mm x 110mm',
            },
            {
              theme: 'Weight',
              desc: 'Approx. 800g',
            },
            {
              theme: 'Application',
              desc: 'Video Monitoring / Surveillance',
            },
            {
              theme: 'Form Factor',
              desc: 'Dome-type Camera',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Image Sensor',
              desc: '1/2.8” Progressive Scan CMOS',
            },
            {
              theme: 'Resolution',
              desc: '1920 × 1080',
            },
            {
              theme: 'Lens',
              desc: 'Fixed Lens (Options: 2.8mm and 4mm)',
            },
            {
              theme: 'Aperture',
              desc: 'F1.4',
            },
            {
              theme: 'Ingress Protection',
              desc: 'IP67',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Wired',
              desc: 'RJ45 10M/100M Self-adaptive Ethernet Port × 1',
            },
            {
              theme: 'Alarm I/O',
              desc: '1 Alarm Input, 1 Alarm Output (Max. 12 VDC, 30 mA)',
            },
            {
              theme: 'Power Supply',
              desc: '12 VDC',
            },
            {
              theme: 'Operating Temperature',
              desc: '-30°C to +60°C',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 95% (non-condensing)',
            },
          ],
        },
      ],
    },
  ],

  ptzCamera: [
    {
      title: 'PTZ Camera',
      serial: '', // 시리얼 번호가 없으므로 빈 값 유지
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimension',
              desc: '266mm × 266mm × 410mm',
            },
            {
              theme: 'Application',
              desc: 'Long-range Surveillance / Outdoor Monitoring',
            },
            {
              theme: 'Form Factor',
              desc: 'PTZ Camera',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Image Sensor',
              desc: '1/1.8” Progressive Scan CMOS',
            },
            {
              theme: 'Resolution',
              desc: '2560 × 1440',
            },
            {
              theme: 'Zoom',
              desc: '42× Optical, 16× Digital',
            },
            {
              theme: 'Focal Length',
              desc: '6.0mm – 252mm',
            },
            {
              theme: 'Aperture',
              desc: 'F1.2',
            },
            {
              theme: 'Zoom Speed',
              desc: '4.5 seconds',
            },
            {
              theme: 'PTZ Range',
              desc: 'Pan: 360°, Tilt: -20° to +90°',
            },
            {
              theme: 'Ingress Protection',
              desc: 'IP67',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Wired',
              desc: '1 RJ45 10M/100M Ethernet Port, Hi-PoE Supported',
            },
            {
              theme: 'Alarm I/O',
              desc: '7 Inputs, 2 Outputs',
            },
            {
              theme: 'Power Supply',
              desc: '24VAC, PoE',
            },
            {
              theme: 'Operating Temperature',
              desc: '-40°C to +70°C',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 95% (non-condensing)',
            },
          ],
        },
      ],
    },
  ],

  orbroServer: [
    {
      title: 'ORBRO Server',
      serial: 'ONT-SVNO50001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Port Layout',
              desc: '1GbE RJ 45 × 5',
            },
            {
              theme: 'Application',
              desc: 'ORBRO OS',
            },
            {
              theme: 'Form Factor',
              desc: '1U Server',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Processor',
              desc: 'Intel Xeon E-2334 (3.4GHz, 4Core, 8MB L3 Cache, 65W)',
            },
            {
              theme: 'Memory',
              desc: '16GB 3200MT/s DDR4 ECC UDIMM (Max 64GB, 4 slots)',
            },
            {
              theme: 'Storage',
              desc: '1TB 7.2K RPM SATA 3.5” HDD',
            },
            {
              theme: 'Network Controller',
              desc: 'Onboard Broadcom 5720 Dual Port 1Gb LOM',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Expansion Slot',
              desc: '2 PCIe slots',
            },
            {
              theme: 'Power Supply',
              desc: 'Dual, Hot-plug, Redundant (1+1), 600W',
            },
            {
              theme: 'Weight',
              desc: '12.2kg',
            },
            {
              theme: 'Enclosure Material',
              desc: 'Metal Chassis',
            },
            {
              theme: 'Ambient Operating Temperature',
              desc: '-5 to 45°C (23 to 113°F)',
            },
            {
              theme: 'Ambient Operating Humidity',
              desc: '10 to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],

  aiServer: [
    {
      title: 'ORBRO AI Server',
      serial: 'OET-SVAI5001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Description',
              desc: 'A high-performance server tailored for AI-driven analytics, edge inference, and enterprise-grade machine learning workloads.',
            },
            {
              theme: 'Highlights',
              desc: 'Equipped with Intel Xeon architecture, ECC memory, and the NVIDIA RTX A4000 GPU, the ORBRO AI Server delivers reliable performance, scalable compute power, and accelerated AI processing.',
            },
            {
              theme: 'Application',
              desc: 'An AI-powered localization system that analyzes collected images, extracts coordinate data, and transmits it to a central processing system',
            },
            {
              theme: 'Form Factor',
              desc: 'Rack-mountable server',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Processor',
              desc: 'Intel Xeon E-2226G (3.4GHz, 6 Cores, 12MB L3 Cache, 80W)',
            },
            {
              theme: 'Memory',
              desc: '16GB DDR4 ECC UDIMM (up to 128GB, 4 DIMM slots)',
            },
            {
              theme: 'Storage',
              desc: '512GB M.2 SSD + 1TB 7.2K RPM SATA 3.5” HDD',
            },
            {
              theme: 'Graphics',
              desc: 'NVIDIA RTX A4000',
            },
            {
              theme: 'Expansion',
              desc: '2 PCIe slots for future scalability',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Network Controller',
              desc: 'Onboard Broadcom 5720 Dual Port 1Gb LOM',
            },
            {
              theme: 'Power Supply',
              desc: 'Dual hot-plug redundant power supply (1+1), 600W',
            },
            {
              theme: 'Weight',
              desc: '12.2kg',
            },
            {
              theme: 'Enclosure Material',
              desc: 'Metal Chassis',
            },
            {
              theme: 'Ambient Operating Temperature',
              desc: '-5 to 45°C (23 to 113°F)',
            },
            {
              theme: 'Ambient Operating Humidity',
              desc: '10 to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],

  edgeRtls: [
    {
      title: 'ORBRO Edge RTLS',
      serial: 'ONT-ERWF0001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimension',
              desc: '188mm x 108mm x 27mm',
            },
            {
              theme: 'Port Layout',
              desc: '1GbE RJ 45 × 4, HDMI, USB-C, USB-A',
            },
            {
              theme: 'Application',
              desc: 'Real-time Tag Tracking',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact Desktop',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Connectivity',
              desc: 'TwinTracker UWB (Max 8E/A)',
            },
            {
              theme: 'Device Health',
              desc: 'Device health monitoring and control supported',
            },
            {
              theme: 'TDoA Logic',
              desc: 'Supports ORBRO TDoA (Time Difference of Arrival) Logic',
            },
            {
              theme: 'Tracking Capability',
              desc: 'Supports ORBRO UWB Tag Tracking',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Wired',
              desc: 'Ethernet',
            },
            {
              theme: 'Wireless',
              desc: 'Wi-Fi, Bluetooth',
            },
            {
              theme: 'Power',
              desc: '(1) USB Type-C, 5V DC, 3A, (2) PoE',
            },
            {
              theme: 'Weight',
              desc: '300g',
            },
            {
              theme: 'Enclosure Material',
              desc: 'ABS/White, PC/Translucent White',
            },
            {
              theme: 'Ambient Operating Temperature',
              desc: '-5 to 45°C (23 to 113°F)',
            },
            {
              theme: 'Ambient Operating Humidity',
              desc: '10 to 90% noncondensing',
            },
            {
              theme: 'Certifications',
              desc: 'KC',
            },
          ],
        },
      ],
    },
  ],

  twinTrackerAoA: [
    {
      title: 'TwinTracker AoA',
      serial: 'OTR-TTAO0001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '144mm x 144mm x 32.5mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Anchor device',
            },
            {
              theme: 'Application',
              desc: 'BLE AoA tag-based real-time location tracking',
            },
            {
              theme: 'Enclosure Material',
              desc: 'ABS (White), PC (Translucent White), Aluminum (Black)',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Tracking Technology',
              desc: 'BLE 5.2 AoA Tag Tracking (Angle of Arrival)',
            },
            {
              theme: 'Direction-Finding',
              desc: 'Accurate direction-finding using BLE antenna arrays',
            },
            {
              theme: 'Use Case',
              desc: 'Designed for indoor positioning and asset tracking',
            },
            {
              theme: 'Reliability',
              desc: 'Stable performance in diverse deployment conditions',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Dual-core 32-bit LX6, 240MHz',
            },
            {
              theme: 'Memory',
              desc: '448KB ROM, 520KB SRAM',
            },
            {
              theme: 'Network',
              desc: '100Base-TX Ethernet, Wi-Fi 802.11b/g/n, BLE 5.2',
            },
            {
              theme: 'Interface',
              desc: 'RS232 (via USB Console)',
            },
            {
              theme: 'Power Supply',
              desc: '3.2W, PoE (802.3af), USB 5V',
            },
            {
              theme: 'Operating Temperature',
              desc: '0°C to +50°C (32°F to 122°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],
  twinTrackerBle: [
    {
      title: 'TwinTracker BLE',
      serial: 'OTR-TTBT0001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '95mm x 95mm x 32.5mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Anchor device',
            },
            {
              theme: 'Application',
              desc: 'BLE tag-based real-time location tracking',
            },
            {
              theme: 'Enclosure Material',
              desc: 'ABS (White), PC (Translucent White), Aluminum (Black)',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Tracking Technology',
              desc: 'BLE 5.2 Tag Tracking',
            },
            {
              theme: 'Positioning',
              desc: 'Optimized for real-time indoor positioning',
            },
            {
              theme: 'Communication',
              desc: 'Low-latency communication via Wi-Fi and Ethernet',
            },
            {
              theme: 'Processing',
              desc: 'Efficient processing with embedded dual-core CPU',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Dual-core 32-bit LX6, 240MHz',
            },
            {
              theme: 'Memory',
              desc: '448KB ROM, 520KB SRAM',
            },
            {
              theme: 'Network',
              desc: '100Base-TX Ethernet, Wi-Fi 802.11b/g/n, BLE 5.2',
            },
            {
              theme: 'Interface',
              desc: 'RS232 (via USB Console)',
            },
            {
              theme: 'Power Supply',
              desc: '3.2W, PoE (802.3af), USB 5V',
            },
            {
              theme: 'Operating Temperature',
              desc: '0°C to +50°C (32°F to 122°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],
  orbroTag: [
    {
      title: 'ORBRO Tag',
      serial: 'OAS-OTBT1991',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '48.4mm x 48.4mm x 10.7mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact BLE Tag',
            },
            {
              theme: 'Material',
              desc: 'ABS (White / Black), PC (Translucent)',
            },
            {
              theme: 'Weight',
              desc: '20g',
            },
            {
              theme: 'Application',
              desc: 'Asset tracking, personnel monitoring, indoor localization',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Wireless Technology',
              desc: 'BLE 5.2 for reliable low-energy broadcasting',
            },
            {
              theme: 'Durability',
              desc: 'Lightweight and durable for wearable or attachable use',
            },
            {
              theme: 'Optimization',
              desc: 'Optimized for indoor tracking systems and low-power operation',
            },
            {
              theme: 'Stability',
              desc: 'Stable performance in temperature-controlled environments',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Cortex-M4, 64MHz',
            },
            {
              theme: 'Memory',
              desc: '512KB Flash',
            },
            {
              theme: 'Wireless',
              desc: 'BLE 5.2',
            },
            {
              theme: 'Power Supply',
              desc: 'CR2450 battery',
            },
            {
              theme: 'Operating Temperature',
              desc: '-20°C to +40°C (-4°F to 104°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],
  plutoconPro: [
    {
      title: 'Plutocon Pro',
      serial: 'KB-BK02',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '85.4mm x 85.4mm x 24.5mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Industrial BLE beacon',
            },
            {
              theme: 'Material',
              desc: 'ABS (White / Gray / Black), PC (Translucent)',
            },
            {
              theme: 'Application',
              desc: 'Proximity tracking, status alerting, industrial monitoring',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Wireless Communication',
              desc: 'BLE 5.2 communication for stable and efficient broadcasting',
            },
            {
              theme: 'Indicators',
              desc: 'RGB LED indicators (×3) for multi-status alerts',
            },
            {
              theme: 'Environment Adaptability',
              desc: 'Designed for industrial and harsh environments',
            },
            {
              theme: 'Battery Life',
              desc: 'Long battery life for extended operational use',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Cortex-M4, 64MHz',
            },
            {
              theme: 'Memory',
              desc: '512KB Flash, 64KB RAM',
            },
            {
              theme: 'Wireless',
              desc: 'BLE 5.2',
            },
            {
              theme: 'Interface',
              desc: 'RGB LED × 4 (status/alarm indicator)',
            },
            {
              theme: 'Power Supply',
              desc: 'CR2477 battery × 4',
            },
            {
              theme: 'Operating Temperature',
              desc: '-10°C to +60°C (14°F to 140°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],

  coinTag: [
    {
      title: 'Coin Tag',
      serial: 'CD16BTR01X',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: 'Diameter 27mm × Thickness 6.9mm',
            },
            {
              theme: 'Weight',
              desc: 'Approx. 7.25g (±5%)',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact BLE Sticker Tag',
            },
            {
              theme: 'Application',
              desc: 'Designed for asset tracking by attaching to boxes, tools, or other objects',
            },
            {
              theme: 'Communication',
              desc: 'BLE 4.2 (Transmit-only)',
            },
            {
              theme: 'Compatibility',
              desc: 'Works with smartphones or BLE gateways for location monitoring',
            },
            {
              theme: 'Certification',
              desc: 'FCC ID: 2AFWN-CD01BTR01X (Certified on 2024-03-06)',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'RF Frequency Range',
              desc: '2402 – 2480 MHz',
            },
            {
              theme: 'TX Power Output',
              desc: '0 to 3 dBm',
            },
            {
              theme: 'Frequency Deviation',
              desc: '±250 kHz (BLE 1Mbps)',
            },
            {
              theme: 'Average Current Consumption<br/>  •  TX Mode: approx. 150 µA<br/>  •  Sleep Mode: approx. 0.7 µA',
              desc: '',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Power Supply Voltage',
              desc: 'Rated 3.0V (Operating range: 1.7V ~ 3.5V)',
            },
            {
              theme: 'Interface',
              desc: 'I²C (IIC)',
            },
            {
              theme: 'Operating Temperature',
              desc: '-10°C to +50°C',
            },
            {
              theme: 'Storage Temperature',
              desc: '-20°C to +60°C',
            },
            {
              theme: 'Compliance',
              desc: 'RoHS Certified',
            },
          ],
        },
      ],
    },
  ],
  slimTag: [
    {
      title: 'Slim Tag',
      serial: 'CD16BTS01X',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '41.48 mm × 28.39 mm × 2.6 mm',
            },
            {
              theme: 'Weight',
              desc: 'Approximately 3.85 g (±5%)',
            },
            {
              theme: 'Form Factor',
              desc: 'Ultra-slim BLE sticker tag',
            },
            {
              theme: 'Application',
              desc: 'Ideal for asset tracking by attaching to boxes, equipment, or other items',
            },
            {
              theme: 'Communication',
              desc: 'Bluetooth Low Energy (BLE) 4.2, transmit-only',
            },
            {
              theme: 'Compatibility',
              desc: 'Operates with smartphones or BLE gateways for location monitoring',
            },
            {
              theme: 'Certification',
              desc: 'FCC ID: 2AFWN-CD01BTS01X (Certified on 2024-02-29)',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Transmit Frequency',
              desc: '2402 MHz – 2480 MHz',
            },
            {
              theme: 'Transmit Power',
              desc: '4 dBm (BLE 1 Mbps)',
            },
            {
              theme: 'Frequency Deviation',
              desc: '±250 kHz',
            },
            {
              theme: 'Average Current Consumption<br/>  •  Advertising Mode: 150 µA<br/>  •  Sleep Mode: 1.7 µA',
              desc: '',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Power Supply Voltage',
              desc: 'Rated 3.0V (Operating range: 1.7V ~ 3.5V)',
            },
            {
              theme: 'Interface',
              desc: 'I²C (IIC)',
            },
            {
              theme: 'Operating Temperature',
              desc: '-10°C to +50°C',
            },
            {
              theme: 'Storage Temperature',
              desc: '-20°C to +60°C',
            },
            {
              theme: 'Compliance',
              desc: 'RoHS Certified',
            },
          ],
        },
      ],
    },
  ],

  stickerTag: [
    {
      title: 'Sticker Tag',
      serial: 'CD16BTS01W',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '31 mm × 72 mm × 0.8 mm',
            },
            {
              theme: 'Weight',
              desc: 'Approximately 3.85 g (±5%)',
            },
            {
              theme: 'Form Factor',
              desc: 'Ultra-slim BLE sticker tag',
            },
            {
              theme: 'Application',
              desc: 'Ideal for asset tracking by attaching to boxes, equipment, or other items',
            },
            {
              theme: 'Communication',
              desc: 'Bluetooth Low Energy (BLE) 5.0, transmit-only',
            },
            {
              theme: 'Compatibility',
              desc: 'Operates with smartphones or BLE gateways for location monitoring',
            },
            {
              theme: 'Certification',
              desc: 'FCC ID: 2AFWN-CD16BTS01W (Certified on 2023-11-27)',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Transmit Frequency',
              desc: '2400 MHz – 2500 MHz',
            },
            {
              theme: 'Transmit Power',
              desc: '-4 dBm',
            },
            {
              theme: 'Frequency Deviation',
              desc: '±250 kHz',
            },
            {
              theme: 'Average Current Consumption<br/>  •  Advertising Mode: 63 µA<br/>  •  Sleep Mode: 2 µA',
              desc: '',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Power Supply Voltage',
              desc: 'Nominal 3.0V (Operating range: 1.7V ~ 3.3V)',
            },
            {
              theme: 'Interface',
              desc: 'UART',
            },
            {
              theme: 'Operating Temperature',
              desc: '-10°C to +50°C',
            },
            {
              theme: 'Storage Temperature',
              desc: '-20°C to +60°C',
            },
            {
              theme: 'Compliance',
              desc: 'RoHS Certified',
            },
          ],
        },
      ],
    },
  ],
  orbroAoaTag: [
    {
      title: 'ORBRO AoA Tag',
      serial: 'OAS-OTAO1991',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '48.4mm x 48.4mm x 10.7mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact BLE AoA Tag',
            },
            {
              theme: 'Material',
              desc: 'ABS (White / Black), PC (Translucent)',
            },
            {
              theme: 'Weight',
              desc: '20g',
            },
            {
              theme: 'Application',
              desc: 'High-accuracy indoor positioning, asset & personnel tracking using AoA technology',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'BLE Support',
              desc: 'Supports BLE 5.2 Direction Finding (AoA-compatible)',
            },
            {
              theme: 'Signal Optimization',
              desc: 'Optimized signal characteristics for angle calculation in AoA tracking systems',
            },
            {
              theme: 'Durability',
              desc: 'Lightweight and durable for wearable or equipment-mount use',
            },
            {
              theme: 'Stability',
              desc: 'Designed for stable performance in controlled indoor environments',
            },
            {
              theme: 'Power Efficiency',
              desc: 'Low-power design enabling long battery life in continuous tracking mode',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Cortex-M4, 64MHz',
            },
            {
              theme: 'Memory',
              desc: '512KB Flash',
            },
            {
              theme: 'Wireless',
              desc: 'BLE 5.2 with Direction Finding support',
            },
            {
              theme: 'Antenna',
              desc: 'Internal omnidirectional (optimized for AoA reception by locator infrastructure)',
            },
            {
              theme: 'Power Supply',
              desc: 'CR2450 battery',
            },
            {
              theme: 'Operating Temperature',
              desc: '-20°C to +40°C (-4°F to 104°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],

  twinTrackerUWB: [
    {
      title: 'TwinTracker UWB',
      serial: 'OTR-TTUW0001',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '95mm x 95mm x 32.5mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Anchor device',
            },
            {
              theme: 'Application',
              desc: 'UWB tag-based real-time location tracking',
            },
            {
              theme: 'Enclosure Material',
              desc: 'ABS (White), PC (Translucent White), Aluminum (Black)',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'UWB Tracking',
              desc: 'High-accuracy positioning for real-time applications',
            },
            {
              theme: 'Optimization',
              desc: 'Optimized for indoor ultra-wideband (UWB) environments',
            },
            {
              theme: 'Reliability',
              desc: 'Reliable performance under diverse industrial conditions',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Dual-core 32-bit LX6, 240MHz',
            },
            {
              theme: 'Memory',
              desc: '448KB ROM, 520KB SRAM',
            },
            {
              theme: 'Network',
              desc: '100Base-TX Ethernet, Wi-Fi 802.11b/g/n, BLE 5.2',
            },
            {
              theme: 'Interface',
              desc: 'RS232 (via USB Console)',
            },
            {
              theme: 'Power Supply',
              desc: '3.2W, PoE (802.3af), USB 5V',
            },
            {
              theme: 'Operating Temperature',
              desc: '0°C to +50°C (32°F to 122°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],

  uwbTag: [
    {
      title: 'UWB Tag',
      serial: 'OTR-UTUW2062',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Dimensions',
              desc: '55.0mm x 66.0mm x 20.0mm',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact UWB Tag',
            },
            {
              theme: 'Material',
              desc: 'ABS (Black)',
            },
            {
              theme: 'Application',
              desc: 'Real-time location tracking using UWB',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Communication',
              desc: 'Ultra-Wideband (UWB) communication based on IEEE 802.15.4',
            },
            {
              theme: 'Precision',
              desc: 'High-precision ranging for RTLS (Real-Time Location System)',
            },
            {
              theme: 'Latency',
              desc: 'Designed for low-latency, high-accuracy indoor positioning',
            },
            {
              theme: 'Stability',
              desc: 'Stable performance in industrial and commercial environments',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Processor',
              desc: 'Cortex-M4, 64MHz',
            },
            {
              theme: 'Memory',
              desc: '512KB Flash',
            },
            {
              theme: 'Wireless',
              desc: 'UWB (802.15.4 compliant)',
            },
            {
              theme: 'Power Supply',
              desc: 'USB Type-C',
            },
            {
              theme: 'Operating Temperature',
              desc: '-20°C to +50°C (-4°F to 122°F)',
            },
            {
              theme: 'Operating Humidity',
              desc: '0% to 90% non-condensing',
            },
          ],
        },
      ],
    },
  ],

  gps: [
    {
      title: 'GPS Device',
      serial: 'OTR-GD4G2121',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Description',
              desc: 'A compact GNSS tracking device designed for outdoor real-time asset and vehicle tracking. Equipped with a high-precision Ublox GNSS chipset and built-in LTE-M (Cat-M1) communication module, it enables reliable location tracking even in remote areas. Ideal for fleet management, mobile asset monitoring, and GPS-based system integration with ORBRO OS.',
            },
            {
              theme: 'Application',
              desc: 'Fleet management, vehicle movement logging, rental equipment tracking, construction asset monitoring, and outdoor asset security. Fully compatible with ORBRO OS for data visualization and integration with real-time location systems.',
            },
            {
              theme: 'Form Factor',
              desc: 'Portable enclosure',
            },
            {
              theme: 'Weight',
              desc: '200g',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Positioning Accuracy',
              desc: 'Supports multi-GNSS (GPS, GLONASS, BeiDou) with an average accuracy within ±3 meters',
            },
            {
              theme: 'Update Rate',
              desc: 'Configurable to transmit location data up to 10 times per minute (every 6 seconds)',
            },
            {
              theme: 'Data Upload',
              desc: 'Location data can be transmitted to central servers or the cloud via LTE-M or BLE (depending on configuration)',
            },
            {
              theme: 'Power Optimization',
              desc: 'Supports power-saving modes such as motion-based reporting and sleep mode for extended battery life',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'GNSS Receiver',
              desc: 'Multi-constellation GNSS receiver supporting GPS, GLONASS, BeiDou',
            },
            {
              theme: 'Cellular Module',
              desc: 'LTE-M (Cat-M1) communication module with optional NB-IoT support',
            },
            {
              theme: 'Antenna',
              desc: 'High-sensitivity internal antenna for stable signal reception in mobile environments',
            },
            {
              theme: 'Battery',
              desc: 'Rechargeable lithium battery supporting up to 150 days of operation in power-saving mode',
            },
            {
              theme: 'Interface',
              desc: 'USB Type-C port for charging and data connectivity',
            },
            {
              theme: 'Indicators',
              desc: 'LED indicators showing GNSS fix status and battery level',
            },
            {
              theme: 'Enclosure',
              desc: 'Durable, water- and shock-resistant housing (IP-rated)',
            },
          ],
        },
      ],
    },
  ],

  loraGateway: [
    {
      title: 'LoRA Gateway',
      serial: 'ALESS-GW',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Description',
              desc: 'LoRA Gateway is a robust industrial-grade wireless communication device designed to extend connectivity across long distances using the LoRA protocol. It supports multiple backhaul options including Ethernet, Wi-Fi, and LTE, and is ideal for outdoor deployment in smart city, agriculture, and industrial IoT environments.',
            },
            {
              theme: 'Dimensions',
              desc: '145mm x 145mm x 42mm',
            },
            {
              theme: 'Weight',
              desc: '750g',
            },
            {
              theme: 'Form Factor',
              desc: 'Compact outdoor gateway',
            },
            {
              theme: 'Material',
              desc: 'Aluminum (Gray)',
            },
            {
              theme: 'RF Frequency Range',
              desc: '920.9MHz – 923.1MHz (Bandwidth 125kHz)',
            },
            {
              theme: 'Line of Sight Range',
              desc: 'Up to 6 km',
            },
            {
              theme: 'Antenna Sensitivity',
              desc: '-135 dBm',
            },
            {
              theme: 'Transmission Power',
              desc: '20 dBm',
            },
            {
              theme: 'Security',
              desc: 'AES-128 Encryption',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Connectivity',
              desc: 'Long-range, low-power LoRA connectivity',
            },
            {
              theme: 'Backhaul',
              desc: 'Flexible backhaul: Ethernet, Wi-Fi, LTE',
            },
            {
              theme: 'Reliability',
              desc: 'Industrial reliability with IP67 protection',
            },
            {
              theme: 'Encryption',
              desc: 'Secure transmission with AES-128 encryption',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'Ethernet',
              desc: '10/100 Ethernet Controller, IEEE 802.3 compliant, supports Full–Duplex and Half–Duplex modes',
            },
            {
              theme: 'Protocols',
              desc: 'DHCP, DNS, NTP, UDP, TCP, SNMP',
            },
            {
              theme: 'Wi-Fi',
              desc: 'IEEE 802.11b/g/n (2.4GHz)',
            },
            {
              theme: 'Cellular LTE',
              desc: 'LTE Cat M1 (Telit ME910C1)',
            },
            {
              theme: 'SIM Format',
              desc: 'Micro-SIM (3FF), 15mm x 12mm x 0.76mm',
            },
            {
              theme: 'Power Supply',
              desc: 'DC 8V to 24V',
            },
            {
              theme: 'Operating Temperature',
              desc: '-20°C to +60°C (-4°F to 140°F)',
            },
            {
              theme: 'Certifications',
              desc: 'KC, IP67 (Water and Dust Resistant)',
            },
          ],
        },
      ],
    },
  ],

  gpsTagLora: [
    {
      title: 'GPS Tag (LoRA)',
      serial: 'OTR-GTLR2121',
      spec: [
        {
          title: 'Overview',
          desc: [
            {
              theme: 'Description',
              desc: 'A rugged outdoor GNSS tracking tag designed for large-area vehicle and asset tracking. It receives precise GNSS signals and transmits location data via LoRA to a nearby gateway without requiring cellular communication. Ideal for yards, ports, and construction sites where LTE connectivity is unreliable or costly.',
            },
          ],
        },
        {
          title: 'Performance',
          desc: [
            {
              theme: 'Tracking',
              desc: 'GNSS-based real-time location tracking (GPS, GLONASS, BeiDou)',
            },
            {
              theme: 'Accuracy',
              desc: 'Positioning accuracy within ±3 meters',
            },
            {
              theme: 'LoRA Transmission',
              desc: 'Optimized for long-range and low-power operations',
            },
            {
              theme: 'Reporting Interval',
              desc: 'Configurable transmission intervals (e.g., every 30 seconds or 1 minute)',
            },
            {
              theme: 'Power Saving',
              desc: 'Power-saving modes with motion-triggered reporting',
            },
            {
              theme: 'Battery Life',
              desc: 'Supports operation for up to 6–12 months depending on transmission settings',
            },
          ],
        },
        {
          title: 'Hardware',
          desc: [
            {
              theme: 'GNSS Receiver',
              desc: 'Multi-constellation GNSS chipset (GPS/GLONASS/BeiDou)',
            },
            {
              theme: 'Communication',
              desc: 'Integrated LoRA transmitter (920–923 MHz band)',
            },
            {
              theme: 'Antenna',
              desc: 'Built-in GNSS antenna and LoRA antenna',
            },
            {
              theme: 'Battery',
              desc: 'Rechargeable or replaceable lithium battery (large capacity for extended operation)',
            },
            {
              theme: 'Enclosure',
              desc: 'IP67-rated waterproof and dustproof ruggedized casing',
            },
            {
              theme: 'Interface',
              desc: 'USB Type-C charging port',
            },
            {
              theme: 'Indicators',
              desc: 'LED lights for GNSS lock and transmission status',
            },
            {
              theme: 'Mounting',
              desc: 'Screw holes and adhesive options for vehicle or asset attachment',
            },
            {
              theme: 'Operating Environment',
              desc: '-20°C to +60°C, 5%–95% RH non-condensing',
            },
            {
              theme: 'Warranty',
              desc: '1-year limited hardware warranty',
            },
          ],
        },
      ],
    },
  ],
};
